import { CityLocationsPage } from "@/components/locations/CityLocationsPage";
import {
  ANTALYA_DESTINATIONS,
  antalyaDestinationPath,
  antalyaHubPath,
} from "@/data/antalyaLocations";

const AntalyaLocations = () => (
  <CityLocationsPage
    citySlug="antalya"
    destinations={ANTALYA_DESTINATIONS}
    destinationPath={antalyaDestinationPath}
    hubPath={antalyaHubPath}
  />
);

export default AntalyaLocations;
